import { Card, Grid, IconButton } from "@material-ui/core";
import * as React from "react";
import { GetUserInfoResponse, NoteWithComments } from "../../network/APITypes";
import { THEME } from "../../theme/ThemeStore";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import {
    AuthorField,
    CommentsCointainer,
    CommentsToggle,
    NoteMentions,
    SectionHeaderSmall,
    TextPreview
} from "./Primitives";

type Props = {
    note: NoteWithComments;
    handleOpenNoteDialog: (note?: NoteWithComments) => void;
    handleOpenDeleteDialog: (note: NoteWithComments) => void;
    setComment: React.Dispatch<React.SetStateAction<string | undefined>>;
    userInfo: GetUserInfoResponse | null;
};

// TODO do not provide handlers as props us proper handler like onClickComment etc. instead
export const ApplicantNote = ({ note, handleOpenNoteDialog, handleOpenDeleteDialog, setComment, userInfo }: Props) => {
    const isMobile = useMobileMediaQuery();

    const [showComments, setShowComments] = React.useState(false);

    return (
        <Grid item xs={isMobile ? 12 : 6} key={note.id}>
            <Card className="blackDalBorder" style={{ padding: 24, gap: 8, display: "flex", flexDirection: "column" }}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingBottom: 16,
                        gap: 32
                    }}
                    className="noteHeader"
                >
                    <SectionHeaderSmall
                        label={note.title}
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap"
                        }}
                    />
                    <div style={{ gap: 16, display: "flex" }}>
                        <img
                            src={THEME.Images.icComment}
                            alt=""
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                handleOpenNoteDialog();
                                setComment(note.id);
                            }}
                        />
                        <img
                            src={THEME.Images.icDelete}
                            alt=""
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                handleOpenDeleteDialog(note);
                                setComment(undefined);
                            }}
                        />
                        <img
                            src={THEME.Images.icEdit}
                            alt=""
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                handleOpenNoteDialog(note);
                                setComment(undefined);
                            }}
                        />
                    </div>
                </div>
                <TextPreview style={{ marginBottom: 8, whiteSpace: "pre-line" }}>{note.content}</TextPreview>
                <AuthorField type="created" user={note.createdBy} date={note.createdAt} />
                <AuthorField type="updated" user={note.updatedBy} date={note.updatedAt} />
                <NoteMentions mentions={note.mentions} />
                <CommentsToggle
                    comments={note.comments}
                    setShowComments={setShowComments}
                    showComments={showComments}
                />
                {note.comments && showComments && (
                    <CommentsCointainer className="commentsContainer">
                        {note.comments.map((comment, index) => (
                            <div
                                key={index}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 8,
                                    paddingBottom: 8
                                }}
                                className="comment"
                            >
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <AuthorField type="created" user={comment.createdBy} date={comment.createdAt} />
                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <IconButton
                                            onClick={() => {
                                                handleOpenDeleteDialog({ ...comment, title: "" });
                                                setComment(note.id);
                                            }}
                                            disabled={userInfo !== null && userInfo.email !== comment.createdBy.email}
                                        >
                                            <img
                                                src={THEME.Images.icDelete}
                                                alt=""
                                                style={{
                                                    height: 20,
                                                    width: 20,
                                                    opacity:
                                                        userInfo !== null && userInfo.email !== comment.createdBy.email
                                                            ? 0.5
                                                            : 1
                                                }}
                                            />
                                        </IconButton>
                                        <IconButton
                                            onClick={() => {
                                                handleOpenNoteDialog({ ...comment, title: "" });
                                                setComment(note.id);
                                            }}
                                            disabled={userInfo !== null && userInfo.email !== comment.createdBy.email}
                                        >
                                            <img
                                                src={THEME.Images.icEdit}
                                                alt=""
                                                style={{
                                                    height: 20,
                                                    width: 20,
                                                    opacity:
                                                        userInfo !== null && userInfo.email !== comment.createdBy.email
                                                            ? 0.5
                                                            : 1
                                                }}
                                            />
                                        </IconButton>
                                    </div>
                                </div>
                                <TextPreview style={{ whiteSpace: "pre-line" }} showButton>
                                    {comment.content}
                                </TextPreview>
                                <NoteMentions mentions={comment.mentions} />
                            </div>
                        ))}
                    </CommentsCointainer>
                )}
            </Card>
        </Grid>
    );
};
